import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';
import { C08LinkListItemProps } from './C08LinkListItem.types';
import { GetLinkListItemModel } from './C08LinkListItem.service';
import { Anchor } from '@ahc-digital/component-library';

const Default = (props?: C08LinkListItemProps) => {
  const model = GetLinkListItemModel(props);
  return model && <Anchor>{model.link}</Anchor>;
};

export default checkDatasourceForRendering<C08LinkListItemProps>(Default);
